import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { elementTraversal } from "../../actionHelpers/elementTraversal";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";

export interface IBringToFrontElementActionPayload {
  id: string;
  prevZIndex: number;
  nextZIndex: number;
}

export interface IBringToFrontElementAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.BRING_TO_FRONT_ELEMENT;
  payload: IBringToFrontElementActionPayload;
}

export function getBringToFrontElementInverseAction(action: IBringToFrontElementAction): IBringToFrontElementAction {
  const { id, prevZIndex, nextZIndex } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.BRING_TO_FRONT_ELEMENT,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevZIndex: nextZIndex,
      nextZIndex: prevZIndex,
    },
  };
}

export function applyBringToFrontElementChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IBringToFrontElementAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextZIndex } = action.payload;

  return elementTraversal(header, root, footer, id, { zIndex: nextZIndex });
}
